import { render } from "./LabeledConfidenceLevelDropDown.vue?vue&type=template&id=12d98804&scoped=true"
import script from "./LabeledConfidenceLevelDropDown.vue?vue&type=script&lang=js"
export * from "./LabeledConfidenceLevelDropDown.vue?vue&type=script&lang=js"

import "./LabeledConfidenceLevelDropDown.vue?vue&type=style&index=0&id=12d98804&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-12d98804"

export default script